import React from 'react';
import { FileText, Users, LogOut, BarChart } from 'lucide-react';
const LayoutSidebar = ({ userRole, onNavigate, currentPage }) => {
    const navItems = [
        {
            name: 'Crear Oficio',
            page: 'createOffice',
            icon: FileText,
            roles: ['EMISOR', 'ADMIN'],
        },
        {
            name: 'Listar Oficios',
            page: 'listOffices',
            icon: BarChart,
            roles: ['EMISOR', 'VISOR', 'ADMIN'],
        },
        {
            name: 'Gestionar Usuarios',
            page: 'manageUsers',
            icon: Users,
            roles: ['ADMIN'],
        },
    ];

    return (
        <aside className="w-64 bg-slate-900 text-white flex flex-col rounded-lg m-4">
            <div className="p-4 text-xl font-semibold border-b border-gray-700">
                CICSA Folios {}
            </div>
            <nav className="flex-1 px-2 py-4 space-y-2">
                {navItems.map((item) => {
                    if (item.roles.includes(userRole)) {
                        const IconComponent = item.icon;
                        return (
                            <button
                                key={item.page}
                                onClick={() => onNavigate(item.page)}
                                className={`flex items-center w-full px-3 py-2 rounded-md text-sm font-medium 
                                    ${currentPage === item.page ? 'bg-gray-700 text-white shadow-md' : 'text-gray-300 hover:bg-gray-700 hover:text-white'}
                                    transition-colors duration-200 ease-in-out`}
                            >
                                {IconComponent && <IconComponent className="mr-3 h-5 w-5" />} {}
                                {item.name}
                            </button>
                        );
                    }
                    return null;
                })}
            </nav>
            <div className="p-4 border-t border-gray-700">
                <button
                    onClick={() => onNavigate('logout')}
                    className="flex items-center w-full px-3 py-2 rounded-md text-sm font-medium text-red-300 hover:bg-red-700 hover:text-white transition-colors duration-200 ease-in-out"
                >
                    <LogOut className="mr-3 h-5 w-5" /> {}
                    Cerrar Sesión
                </button>
            </div>
        </aside>
    );
};

export default LayoutSidebar;
